import React, { Component } from 'react'
import { connect } from "react-redux"
import LoadingOverlay from 'react-loading-overlay';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import { osName } from 'react-device-detect';


import { customerService, activityService } from "../../services"
import { createBrowserHistory } from 'history';
import { alertActions, customerFetch } from "../../actions"
import { deepEqual, Modal } from '../../helpers';
import { IdField, RegistrationTabs } from './components';
import commonConstant, { AboStatusCd, LABEL_FORGET_PASSWORD, LABEL_MEMBER_NOT_FOUND_ALERT_DESCRIPTION, LABEL_MEMBER_NOT_FOUND_ALERT_OK_BTN, LABEL_MEMBER_NOT_FOUND_ALERT_TITLE, LABEL_REGISTRATION_HEADING, LABEL_REGISTRATION_SUBTITLE_BOTTOM, LABEL_REGISTRATION_SUBTITLE_TOP, LABEL_REGISTRATION_TITLE, LABEL_SUBMIT, REGISTRATION_LISTING, REGISTRATION_TABS_MAPPING } from '../../common/commonConstant';
import ListingItem from './components/listingItem/ListingItem';
import StickyBottom from '../../common/stickyButtonFooter/StickyBottom';
import './home.scss';
import HomeAlertModal from './homeAlertModal/HomeAlertModal';
import PublicForm from './components/publicForm/PublicForm';


const liff = window.liff;

export const history = createBrowserHistory();

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            type: "",
            profile: [],
            customer: [],
            show: false,
            error: false,
            loading: false,
            distNum: '',
            isOpenModal: false,
            activeTab: REGISTRATION_TABS_MAPPING.Member.name,
            gender: '',
            name: '',
            lastname: '',
            phone: '',
            birthday: '',
            hasError: false,
            isSubmitActive: false,
            phoneValidationError: null,
            isValidatingPhone: false,
            acceptTermPublic: false,
        }
    }

    componentDidMount() {
        if (process.env.REACT_APP_SKIP_LIFF === 'true') {
            // In local dev mode, show the form directly with mock customer data
            const mockCustomer = {
                registerStatus: 'incomplete',
                action: 'SELECT_TYPE',
                displayName: 'Dev User',
                pictureUrl: '',
                uid: 'U_dev_local_user',
                status: 'unblock',
            };
            sessionStorage.setItem('customer', JSON.stringify(mockCustomer));
            this.setState({ show: true, customer: mockCustomer });
            return;
        }
        if (!isEmpty(this.props.customer) && !isEmpty(this.props.profile)) {
            this.setState({
                show: true
            })
        }
    }

    handleButton = () => {
        liff.closeWindow();
    }

    onTabChange = activeTab => {
        this.setState({
            activeTab,
            distNum: '',
            gender: '',
            name: '',
            lastname: '',
            phone: '',
            birthday: '',
            hasError: false,
            acceptTermPublic: false,
            phoneValidationError: null,
        });
    }

    showError = (errorMessage) => {
        this.setState({ hasError: Boolean(errorMessage) });
    }

    componentDidUpdate(prevProps, prevState) {
        const isTrue = (this.state.activeTab === REGISTRATION_TABS_MAPPING.Member.name && this.state.distNum.length >= 5) ||
            (this.state.activeTab === REGISTRATION_TABS_MAPPING.Public.name && this.state.name && this.state.lastname && this.state.gender && this.state.birthday && this.state.phone.length === 10 && !this.state.hasError && !this.state.phoneValidationError && !this.state.isValidatingPhone);
        prevState.isSubmitActive !== this.state.isSubmitActive && this.setState({ isSubmitActive: isTrue });
    }

    async componentWillReceiveProps(nextProps) {
        let customer = nextProps.customer;
        const { profile } = nextProps;
        if ((Object.keys(profile).length || profile.length) && !deepEqual(this.props.profile, profile)) {
            // let customer = await customerService.get(nextProps.profile.userId)
            this.props.getCustomer();
        }
        if ((Object.keys(profile).length || profile.length) && (!deepEqual(this.props.customer, customer) || customer.hasOwnProperty('action'))) {
            if (!customer) {
                customer = {
                    registerStatus: "incomplete",
                    action: "SELECT_TYPE",
                    displayName: nextProps.profile.displayName,
                    pictureUrl: nextProps.profile.pictureUrl,
                    uid: nextProps.profile.userId,
                    status: "unblock"
                }
            }
            if (!customer.pictureUrl || (customer.pictureUrl !== nextProps.profile.pictureUrl)) {
                customer = {
                    ...customer,
                    pictureUrl: nextProps.profile.pictureUrl
                }
            }
            sessionStorage.setItem("customer", JSON.stringify(customer))
            console.log(customer)

            switch (customer.action) {
                case "REGISTER_COMPLETE":
                    if (customer.type !== 'public') {
                        return this.props.history.push("/success");
                    }
                default:
                    break;
            }
            this.setState({
                show: true,
                customer: customer
            })
        }
    }

    handleChangeGender = (event) => { this.setState({ gender: event.target.value }) };
    handleDobChange = (dob) => { this.setState({ birthday: dob }) };
    handleDobDelete = () => { this.setState({ birthday: '' }) }
    handleTextChange = e => {
        const regex = /^(?!.*[\u0E3F\u0E50-\u0E59])[A-Za-z\u0E00-\u0E4E]{1,50}$/;
        if (e.target.value === '' || regex.test(e.target.value)) {
            this.setState({ [e.target.name]: e.target.value });
        }
    }

    handleMobileChange = e => {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === '' || e.target.value.match(regex)) {
            this.setState({ [e.target.name]: e.target.value, phoneValidationError: null }, () => {
                const phoneRegex = /^[0]{1}[6-9]{1}[0-9]{1}[0-9]{7}$/;
                if (phoneRegex.test(this.state.phone)) {
                    this.validatePhoneNumber(this.state.phone);
                }
            });
        }
    }

    validatePhoneNumber = async (phone) => {
        this.setState({ isValidatingPhone: true });
        const result = await customerService.validatePhone(phone);

        if (result && result.isValid === true) {
            this.setState({ phoneValidationError: false, isValidatingPhone: false });

        } else {
            if (result && result.isValid === false && !result.statusCode) {
                this.setState({ phoneValidationError: 'หมายเลขนี้มีผู้ใช้งานแล้ว กรุณาระบุหมายเลขอื่น', isValidatingPhone: false });
            } else if (result && result.isValid === false && result.statusCode === 429 ) {
                this.setState({ phoneValidationError: 'กรุณารอสักครู่แล้วลองใหม่อีกครั้ง', isValidatingPhone: false });
            } else {
                this.setState({ phoneValidationError: 'เกิดข้อผิดพลาด กรุณารอสักครู่แล้วลองใหม่อีกครั้ง', isValidatingPhone: false });
            }
        }        
    }

    handleCheckValidDate = () => this.state?.birthday && this.state.birthday.getTime();

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({
            loading: true,
        });

        this.state.activeTab === REGISTRATION_TABS_MAPPING.Member.name ?
            this.handleSubmitMember(e) : this.handleSubmitPublic(e);
    }

    handleSubmitPublic = async e => {

        if (typeof this.state.phoneValidationError === "string" || this.state.phoneValidationError == null) {
            this.setState({ loading: false });
            return false;
        }

        if (this.state.acceptTermPublic !== true) {
            this.setState({ loading: false });
            return false;
        }

        if (this.state.name === '') {
            this.setState({
                invalid_name: true,
            });
            return false;
        }
        if (!this.handleCheckValidDate()) {
            this.setState({ loading: false, isOpenModal: true });
            return false;
        }

        const customer = {
            ...this.state.customer,
            name: `${this.state.name} ${this.state.lastname}`,
            birthday: `${this.state.birthday.getFullYear()}-${this.state.birthday.getMonth() + 1}-${this.state.birthday.getDate()}`,
            gender: this.state.gender,
            type: 'public',
            phone: this.state.phone,
            info: osName === 'IOS' ? 'iPhone' : osName,
            _id: this.state.customer._id,
        };

        const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        if (format.test(`${this.state.name} ${this.state.lastname}`)) {
            const errorMessage = customer.message instanceof Object
                ? customer.message.map(value => Object.values(value.constraints))
                : 'ไม่สามารถบันทึก ชื่อ-นามสกุล ที่มีตัวอักษรพิเศษ';

            this.props.showError(errorMessage);
            this.setState({ loading: false });

            return false;
        }

        if (format.test(`${this.state.name} ${this.state.lastname}`)) {
            const errorMessage = customer.message instanceof Object ?
                customer.message.map(value => Object.values(value.constraints)) :
                'ระบบไม่สามารถบันทึกข้อมูลได้กรุณาติดต่อเจ้าหน้าที่';

            this.props.showError(errorMessage);
            this.setState({ loading: false });

            return false;
        }

        const phoneRegex = /[0]{1}[6-9]{1}[0-9]{1}[0-9]{7}/;
        if (!phoneRegex.test(this.state.phone)) {
            const errorMessage = customer.message instanceof Object
                ? customer.message.map(value => Object.values(value.constraints))
                : 'ระบุเบอร์โทรศัพท์ไม่ถูกต้อง';

            this.props.showError(errorMessage);
            this.setState({ loading: false });

            return false;
        }
        sessionStorage.setItem('customer', JSON.stringify(customer));
        this.props.history.push(commonConstant.pathSuccess, { detailType: 'general' });
    }

    handleSubmitMember = async (e) => {

        let customer = JSON.parse(sessionStorage.getItem("customer"));

        const resMemberNumber = await customerService.findMemberbyABONumber(this.state.distNum);

        if (!resMemberNumber || (resMemberNumber?.accountMst?.statusCd.toLowerCase() === AboStatusCd.Inactive)) {
            return this.setState({ isOpenModal: true, loading: false })
        }

        let type;
        switch (resMemberNumber.accountMst.accountTypeCd) {
            case 'AmwayBusiness':
                type = 'abo';
                break;
            case 'Member':
                type = 'member';
                break;
            case 'Customer':
                type = 'foa';
                break;
        }
        if (resMemberNumber.accountMst.accountSubTypeCd === 'Employee') { type = 'employee'; }

        customer = {
            ...customer,
            type
        }
        sessionStorage.setItem("customer", JSON.stringify(customer))

        const params = {
            uid: this.state.customer.uid,
            userId: customer._id,
            status: "incomplete",
            action: "SELECT_TYPE"
        }
        if (resMemberNumber.accountMst.accountTypeCd === 'Member') return this.props.history.push("/member", { myMember: resMemberNumber })
        if (resMemberNumber.accountMst.accountTypeCd === 'AmwayBusiness') return this.props.history.push("/abo", { myMember: resMemberNumber })
        if (resMemberNumber.accountMst.accountTypeCd === 'Customer') {
            return this.props.history.push("/foa", { myMember: resMemberNumber })
        }
    }

    handlePublic = async (e) => {
        e.preventDefault()
        this.setState({
            'loading': true
        })
        const customer = JSON.parse(sessionStorage.getItem("customer"))

        const updated = await customerService.update(customer._id, { type: "public" })
        updated.type = "public"
        sessionStorage.setItem("customer", JSON.stringify(updated))

        const params = {
            uid: this.state.customer.uid,
            userId: customer._id,
            status: "incomplete",
            action: "SELECT_TYPE"
        }
        return this.props.history.push(`/public`)
    }

    handleChange = e => this.setState({ [e.target.name]: e.target.value });
    handleDistNumChange = e => this.setState({ distNum: e.target.value.replace(/[^0-9.]/g, '') });
    handleAcceptChange = () => this.setState({ acceptTermPublic: !this.state.acceptTermPublic });

    handleModalOk = () => this.setState({ isOpenModal: false })

    render() {
        const { location } = this.props;
        const { distNum, show, loading, isOpenModal } = this.state;
        const isTrue = (this.state.activeTab === REGISTRATION_TABS_MAPPING.Member.name && distNum.length >= 5) ||
            (this.state.activeTab === REGISTRATION_TABS_MAPPING.Public.name && this.state.name && this.state.lastname && this.state.gender && this.state.birthday && this.state.phone.length === 10 && !this.state.hasError);

        if (!show) {
            return (
                <div className="regisPage">
                    <LoadingOverlay
                        active={true}
                        spinner
                        text='Loading'
                        styles={{ wrapper: { height: "100vh", position: "absolute", pointerEvents: "none" } }}
                    />
                </div>
            )
        }

        return (

            <div className="regisPage home">
                <LoadingOverlay
                    active={loading}
                    spinner
                    text='Loading'
                    styles={{ wrapper: { height: "100vh", position: "absolute", pointerEvents: "none" } }}
                />
                {
                    isOpenModal &&
                    <HomeAlertModal
                        title={LABEL_MEMBER_NOT_FOUND_ALERT_TITLE}
                        description={LABEL_MEMBER_NOT_FOUND_ALERT_DESCRIPTION}
                        btnFn={this.handleModalOk}
                        isOpen={isOpenModal}
                        onClose={this.handleModalOk}
                        btnText={LABEL_MEMBER_NOT_FOUND_ALERT_OK_BTN} />
                }
                <div className="logoAmway">
                    <img src="/images/registration/AmwayLineHomeConnectLogo.png" alt="" />
                </div>

                <div className="title">{LABEL_REGISTRATION_TITLE}</div>
                <div className="subtitle">{LABEL_REGISTRATION_SUBTITLE_TOP}</div>
                <div className="subtitle">{LABEL_REGISTRATION_SUBTITLE_BOTTOM}</div>
                <form onSubmit={this.handleSubmit} className="">
                    <RegistrationTabs onTabClick={(activeTab) => this.onTabChange(activeTab)} activeTab={this.state.activeTab} />
                    {this.state.activeTab === REGISTRATION_TABS_MAPPING.Member.name ? <>
                        <div className="home-form-wrapper">
                            <IdField heading={LABEL_REGISTRATION_HEADING}
                                value={distNum}
                                placeholder="ระบุหมายเลขนักธุรกิจ/สมาชิกแอมเวย์"
                                preIconPath="/images/common/IDcardIcon.svg"
                                preIconDisabledPath="/images/common/IDcardIconDisabled.svg"
                                pattern="[0-9]*"
                                type="tel"
                                minLength="5"
                                maxLength="15"
                                onChange={this.handleDistNumChange}
                                onPaste={this.onPaste}
                                name="distNum"
                                required
                                phone="true"
                                className="center"
                            />
                            <div className="home-forget-password-link">
                                <Link className="forget-password" to={{
                                    pathname: '/forgot',
                                    state: { from: location },
                                }}>{LABEL_FORGET_PASSWORD}</Link>
                            </div>
                        </div>
                        <div className="home-feature-listing">
                            {REGISTRATION_LISTING.map((textItem, index) => <ListingItem key={`list${index}`} title={textItem} />)}
                        </div>
                    </> : <PublicForm
                        showError={this.showError}
                        onMobileChange={this.handleMobileChange}
                        onTextChange={this.handleTextChange}
                        onGenderChange={this.handleChangeGender}
                        onDobSubmit={this.handleDobChange}
                        onDobDelete={this.handleDobDelete}
                        name={this.state.name}
                        lastname={this.state.lastname}
                        gender={this.state.gender}
                        birthday={this.state.birthday}
                        phone={this.state.phone}
                        phoneValidationError={this.state.phoneValidationError}
                        accept={this.state.acceptTermPublic}
                        onAcceptChange={this.handleAcceptChange} />}
                    <StickyBottom 
                        onClick={this.handleSubmit} 
                        isActive={this.state.activeTab === REGISTRATION_TABS_MAPPING.Member.name || (this.state.acceptTermPublic === true && this.state.phoneValidationError === false)} 
                        buttonText={LABEL_SUBMIT} buttonProps={{ type: "button", disabled: !(isTrue && (this.state.activeTab === REGISTRATION_TABS_MAPPING.Member.name || this.state.acceptTermPublic)), style: { marginTop: 20 } }} >
                    </StickyBottom>
                </form>
            </div>
        )
    }
}

function mapStateToProps({ profile, customer }) {

    return {
        profile,
        customer
    }
}

function mapDispatchToProps(dispatch) {

    return ({
        showError: (message) => dispatch(alertActions.showError(message)),
        getCustomer: () => dispatch(customerFetch()),
    })
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)